const projects = {
    technova21: {
        key: "technova21",
        image: "https://i.ibb.co/FkpZXWT/Technova-Pic.png",
        title: "TechNova 2022",
        color: "#FFFBFB",
        subtitle: "Branding, UX Design",
        description: "Innovating the design for the inaugural event of UWaterloo's women+ in tech hackathon.",
        categories: "Branding, UX Design",
        prompt: "behind the scene.",
        path: '/portfolio/technova'
    },
    // minilib: {
    //     key: "brand",
    //     image: "https://i.ibb.co/5xbzQxt/143667261-d3776d07-2bc1-4861-afe4-3bc197e4076c.png",
    //     description: "Recording reading progress on the books you want to read.",
    //     color: "#D0DEE7",
    //     title: "Mini Library.",
    //     subtitle: "Personal Project",
    //     categories: "Web Development - React, JavaScript, MongoDB",
    //     prompt: "github.",
    //     path: '/portfolio'
    // },
    mood: {
        key: "mood",
        image: "https://i.ibb.co/ZWGWbLq/i-Phone-X-Mockup.png",
        description: "Cultivating awareness of emotions.",
        title: "moodment.",
        subtitle: "Personal Project",
        categories: "UX Design",
        prompt: "coming soon.",
        path: "/portfolio"
    },
    voicenoted: {
        key: "voicenoted",
        image: "https://i.ibb.co/znzzWFs/Voice-Pic-2.png",
        title: 'voicenoted.',
        color: "#FFE3DC",
        subtitle: 'Hack the North 2021 Finalist',
        description: "Reinventing the podcast experience through notetaking functionality. ",
        categories: "UX Design, Frontend Development",
        prompt: "case study.",
        path: '/portfolio/voicenoted'
    }
}

export default projects;